import React from 'react'

import { CloseOutlined, DownloadOutlined } from '@ant-design/icons'
import { Button, Drawer, Empty, Table } from 'antd'

import {
  reportStatus,
  useCancelReportMutation,
  useGetBackgroundReportsQuery,
  useReportsDrawerState
} from '../../appRedux/ducks/reports'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'
import { Status } from './components/Status'
import styles from './styles.module.less'

export const ReportsDrawer = () => {
  const { toggleShowDrawer, showDrawer } = useReportsDrawerState()

  const [cancelReport] = useCancelReportMutation()

  const downloadFile = async ({ fileKey, fileName }) => {
    await request(api.downloadFile({ fileKey, fileName }))
  }

  const { data: reports = [], isLoading } = useGetBackgroundReportsQuery()

  return (
    <Drawer
      onClose={toggleShowDrawer}
      visible={showDrawer}
      width={700}
      className={styles['drawer']}
      getContainer={false}
      closable={false}
      bodyStyle={{ height: '100%' }}
    >
      {reports.length === 0 ? (
        <div className={styles['drawer-empty-container']}>
          <Empty description={getMessage('noReports')} />
        </div>
      ) : (
        <div className={styles['drawer-content-container']}>
          <div>
            <Table loading={isLoading} dataSource={reports} pagination={false} className={styles['table']}>
              <Table.Column
                title={getMessage('label.status')}
                dataIndex={'status'}
                render={(_, { status }) => <Status status={status} />}
              />

              <Table.Column
                title={getMessage('label.file')}
                dataIndex={'fileName'}
                render={(_, { fileName }) => (
                  <div className={styles['file-name-wrapper']}>
                    <span>{fileName}</span>
                  </div>
                )}
              />

              <Table.Column
                title={getMessage('label.actions')}
                render={(_, { fileKey, fileName, id, status }) => (
                  <div>
                    <Button
                      onClick={() => downloadFile({ fileKey, fileName })}
                      className={styles['button-download']}
                      disabled={status !== reportStatus.COMPLETED}
                    >
                      <span>{getMessage('download')}</span>
                      <DownloadOutlined />
                    </Button>

                    <Button onClick={() => cancelReport(id)} className={styles['button-cancel']}>
                      <CloseOutlined />
                    </Button>
                  </div>
                )}
              />
            </Table>
          </div>
        </div>
      )}
    </Drawer>
  )
}
